import {createTheme, responsiveFontSizes} from "@mui/material";
import montserrat from 'typeface-montserrat';


const breakpoints = {
    values: {
        xs: 0, sm: 400, md: 600, lg: 800, xl: 1000, x2l: 1200, x3l: 1500, x4l: 1800, x5l: 2100
    }
};

const baseTheme = createTheme({
        breakpoints: breakpoints
    }
);

const typography = {
    // fontSize: 12,
    // align: 'justify',
    fontFamily: [
        'Montserrat',
        'Open Sans'].join(','),
    body1: {
        [baseTheme.breakpoints.down('md')]: {fontSize : 14},
        fontWeight: 400,
        align: 'justify'
    },
    h1: {
        fontWeight: 700,
        fontSize: 45,
        letterSpacing: 3,
    },
    h2: {
        fontWeight: 700,
        fontSize: 25,
        letterSpacing: 1,
        textTransform: 'uppercase'
    },
    h5: {
        [baseTheme.breakpoints.down('md')]: {fontSize : 20},
    },
    title_a: {
        fontFamily: 'Montserrat',
        fontWeight: 900,
        [baseTheme.breakpoints.down('lg')]: {fontSize : 30},
        // [baseTheme.breakpoints.down('sm')]: {fontSize : 20},
        fontSize : 40,
        letterSpacing: 6,
        lineHeight: 1,
    },
    title_b: {
        fontFamily: 'Montserrat',
        fontWeight: 600,
        [baseTheme.breakpoints.down('lg')]: { fontSize : 30 },
        // [baseTheme.breakpoints.down('sm')]: { fontSize : 20 },
        fontSize : 40,
        // fontSize: 40,
        letterSpacing: 1,
        lineHeight: 1,
        color: 'black',
    },
    title_c: {
        fontFamily: 'Montserrat',
        fontWeight: 900,
        [baseTheme.breakpoints.down('lg')]: {fontSize : 19},
        // [baseTheme.breakpoints.down('sm')]: {fontSize : 12},
        fontSize: 25,
        letterSpacing: 1,
        lineHeight: 1,
        color: "black"

    },
    title_e: {
        fontFamily: 'Montserrat',
        fontWeight: 800,
        [baseTheme.breakpoints.down('lg')]: {fontSize : 9, letterSpacing: 1},
        // [baseTheme.breakpoints.down('sm')]: {fontSize : 6, letterSpacing: 1},
        fontSize: 11,
        letterSpacing: 1.5,
        // lineHeight: 1,
    },
    h4: {
        // fontWeight: 700,
    },
    h6: {
        fontSize: 17,
        lineHeight: 1.5,
    },
    button: {
        // fontWeight: 800,
        // textTransform: 'none'
    },
    subtitle2: {
        fontSize: '0.8rem',
        align: 'center',
        [baseTheme.breakpoints.down('xxl')]: { fontSize: '0.7rem' },
        [baseTheme.breakpoints.down('xl')]: { fontSize: '0.6rem' },
        [baseTheme.breakpoints.down('lg')]: { fontSize: '0.5rem' },
        [baseTheme.breakpoints.down('md')]: { fontSize: '0.45rem' },
        [baseTheme.breakpoints.down('sm')]: { fontSize: '0.4rem' },
    }
};

export const lightTheme = responsiveFontSizes(createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#3d0060",
        },
        secondary: {
            main: "#705382",
            table_row: "#E3E3E3"
        },
        background: {
            paper: "#ffffff",
            default: "#ffffff",
            top: "rgb(19,19,19)",
            bottom: "#ffeee7",
        },
    },
    typography: typography,
    breakpoints: breakpoints,
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: "#ffffff",
                }
            }
        }
        ,
        MuiButton: {
            styleOverrides: {
                root: {
                    [baseTheme.breakpoints.down('lg')]: {fontSize : 12},
                    [baseTheme.breakpoints.down('md')]: {fontSize : 9},
                }
            }
        },

    },

    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [montserrat],
            },
        },
    },
}));
